module.exports = __webpack_public_path__ + "img/y3.9e16ac68.jpg";